// obj contains anything we might need to send to the server (all optional)
// single variables, or maybe even GameState
import { executeActionSwitch } from '@/action/local_action';
import {
	sendSocketAction,
	sendSocketActionSimple,
} from '@/action/server_action';
import weightTable from '@/const/weights/bestWeights.json';
import { saveGameToJSON } from '@/util/localGameStorage';
import { logg } from '@/util/logg';
import {
	adminUpdateState,
	advanceSummitResolution,
	buyBattery,
	buyFactory,
	buyPR,
	donateEnergy,
	endTurn,
	makeDecision,
	makeDecisionSummitDraftCardId,
	makeDecisionTurnOrder,
	playCard,
	playEquipmentById,
	playSummitCard,
	stealCarbon,
	storeEnergy,
} from '@lc/const/socketEvent';
import { aiCheck } from '@lc/controller/ai_controller';
import { controller_game } from '@lc/controller/game';
import {
	ActionParams,
	CurrPlayerActionParams,
} from '@lc/interface/actionParams/types';
import { CurrPlayer } from '@lc/interface/currPlayer/types';
import { createGameManager } from '@lc/interface/gameManager/factory';
import { GameManager } from '@lc/interface/gameManager/types';
import { GameState } from '@lc/interface/gameState/types';
import { StateChangeEvent } from '@lc/interface/stateChangeEvent/types';
import { isPlayerTurn } from '@lc/lib/player_helper';

async function updateLocalGame(
	gameId: number,
	currPlayer: CurrPlayer,
	gameManager: GameManager,
	setStateChangeHistory
) {
	logg('** LOCAL GAME UPDATED **');
	logg(gameManager.gameState);
	await aiCheck(gameManager);
	setStateChangeHistory([...gameManager.stateChangeHistory]);

	gameManager.currPlayerLocal = currPlayer;
	await saveGameToJSON(gameId, gameManager);
}

export async function performActionLocal(
	action: string,
	currPlayer: CurrPlayer,
	actionParams: ActionParams = {},
	gameId: number,
	gameState: GameState,
	stateChangeHistory: StateChangeEvent[],
	setStateChangeHistory
) {
	const { playerId } = currPlayer;
	if (!isPlayerTurn(playerId ?? -1, gameState)) {
		logg('NOT YOUR TURN, MAGGOT!');
		return;
	}
	logg('called performActionLocal');
	// admin update state call here, enable via settings?

	// so we don't change the state until we confirm it has been altered successfully
	const gs = structuredClone(gameState);
	const sch = structuredClone(stateChangeHistory);
	const gameManager = createGameManager(gameId, gs, sch);

	gameManager.normalSeasonalWeights = weightTable;

	const currPlayerActionParams: CurrPlayerActionParams = {
		...currPlayer,
		...actionParams,
	};

	logg('action', action);
	logg('currPlayerActionParams', currPlayerActionParams);

	let stateChanged = await executeActionSwitch(
		action,
		currPlayerActionParams,
		gameManager
	);

	if (stateChanged) {
		await updateLocalGame(
			gameId,
			currPlayer,
			gameManager,
			setStateChangeHistory
		);
	}
}

export function performActionServer(
	action: string,
	currPlayer: CurrPlayer,
	actionParams: ActionParams = {}
) {
	logg('called performActionServer');
	const currPlayerActionParams: CurrPlayerActionParams = {
		...currPlayer,
		...actionParams,
	};

	switch (action) {
		case advanceSummitResolution:
		case buyBattery:
		case buyPR:
		case buyFactory:
		case donateEnergy:
		case endTurn:
		case makeDecision:
		case makeDecisionSummitDraftCardId:
		case makeDecisionTurnOrder:
		case playCard:
		case playEquipmentById:
		case playSummitCard:
		case storeEnergy:
		case stealCarbon:
			sendSocketActionSimple(action, currPlayerActionParams);
			break;
	}
}

export async function performAdminStateUpdateLocal(
	currPlayer: CurrPlayer,
	gameId: number,
	modalGameState: GameState,
	gameState: GameState,
	stateChangeHistory: StateChangeEvent[],
	setStateChangeHistory
) {
	const { playerId } = currPlayer;
	if (!isPlayerTurn(playerId ?? -1, gameState)) {
		logg('NOT YOUR TURN, MAGGOT!');
		return;
	}

	const gameManager = createGameManager(
		gameId,
		gameState,
		stateChangeHistory
	);
	logg('UPDATING STATE, MAGGOT!');

	let stateChanged = await controller_game.adminUpdateState(
		playerId ?? -1,
		gameManager,
		modalGameState
	);

	if (stateChanged) {
		await updateLocalGame(
			gameId,
			currPlayer,
			gameManager,
			setStateChangeHistory
		);
	}
}

export function performAdminStateUpdateServer(
	currPlayer: CurrPlayer,
	gameId: number,
	modalGameState: GameState
) {}
